import { createContext, useEffect, useMemo, useState } from "react";

export interface TranscriptPermissions {
  edit: boolean;
}

interface TranscriptPermissionsProviderProps {
  children: React.ReactNode;
}

export const TranscriptPermissionsContext = createContext<{
  transcriptPermissions: TranscriptPermissions;
  setTranscriptPermissions: React.Dispatch<
    React.SetStateAction<TranscriptPermissions>
  >;
}>({
  transcriptPermissions: { edit: false },
  setTranscriptPermissions: () => {},
});

export function TranscriptPermissionsProvider({
  children,
}: TranscriptPermissionsProviderProps) {
  const [transcriptPermissions, setTranscriptPermissions] =
    useState<TranscriptPermissions>({
      edit: true,
    });
  useEffect(() => {
    window.debug_setTranscriptPermissions = setTranscriptPermissions;
  }, [setTranscriptPermissions]);

  const value = useMemo(
    () => ({
      transcriptPermissions,
      setTranscriptPermissions,
    }),
    [transcriptPermissions, setTranscriptPermissions],
  );

  return (
    <TranscriptPermissionsContext value={value}>
      {children}
    </TranscriptPermissionsContext>
  );
}
